import React from 'react'

import styles from './AnswersList.module.scss'

const AnswersList = ({ children }) => <div className={styles.answersList}>{children}</div>

export default AnswersList
